export const MINIMUM_VP_REQUIRED_TO_VOTE = 1
